import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { COLORS } from '../../styles/colors';
import { breakpoint } from '../../styles/constants';
import { AlignDiv } from '../radio/WxRadio';

export interface WxSelectProps {
  label: string;
  disabled?: boolean;
  selected?: boolean;
  noLabel?: boolean;
  darkMode?: boolean;
  noUppercase?: boolean;
  onSelect: () => void;
}

const WxCheckbox = ({
  label,
  disabled = false,
  selected = false,
  noLabel = false,
  noUppercase = false,
  darkMode = false,
  onSelect,
}: WxSelectProps) => {
  return (
    <Label
      data-type={selected ? 'selected' : disabled ? 'disabled' : 'neutral'}
      noUppercase={noUppercase}
      onClick={onSelect}
      darkMode={darkMode}
    >
      <AlignDiv>
        <CheckBox>
          <CheckedIcon
            icon={faCheck}
            color={COLORS.red}
            selected={selected}
            size={'sm'}
          />
        </CheckBox>
      </AlignDiv>
      {!noLabel && <p>{label}</p>}
    </Label>
  );
};

const Label = styled.label<{ noUppercase: boolean; darkMode: boolean }>`
  --border-color: ${({ darkMode }) => (darkMode ? COLORS.white : COLORS.black)};
  --radio-size: 1rem;

  font-weight: 300;
  display: flex;
  align-items: flex-start;
  gap: 0.625rem;
  text-transform: ${({ noUppercase }) => (noUppercase ? 'none' : 'uppercase')};
  cursor: pointer;

  font-size: 0.75rem;
  @media (min-width: ${breakpoint}) {
    font-size: 0.875rem;
  }

  input {
    width: var(--radio-size);
    color: var(--border-color);
    height: var(--radio-size);
    border: 1px solid var(--border-color);
    background-color: var(--bg-color, ${COLORS.transparent});
    cursor: pointer;
  }

  span {
    color: var(--text-color, ${COLORS.white});
  }

  &[data-type='disabled'] {
    cursor: default;
    input {
      cursor: default;
    }
  }

  p {
    color: ${({ darkMode }) => (darkMode ? COLORS.white : COLORS.black)};
  }
`;

const CheckBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: var(--radio-size);
  width: var(--radio-size);
  color: var(--border-color);
  height: var(--radio-size);
  border: 1px solid var(--border-color);
  background-color: var(--bg-color, ${COLORS.transparent});
  cursor: pointer;
`;

const CheckedIcon = styled(FontAwesomeIcon)<{ selected: boolean }>`
  opacity: ${({ selected }) => (selected ? '1' : '0')};
  transition: opacity 150ms ease;
`;

export default WxCheckbox;
